import React, {useEffect, useRef, useState} from 'react';
import {BellIcon, ChevronDownIcon} from '@heroicons/react/24/solid';
import NavBarTopMenu from './NavBarTopMenu'; // Import der Hilfsdatei
import NavBarTopUser from './NavBarTopUser';

const NavBarTop = () => {
    // Zustand für das Dropdown-Menü
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null); // Ref für das Dropdown-Menü

    // Funktion zum Umschalten des Dropdown-Menüs
    const toggleDropdown = () => {
        setShowDropdown(prevState => !prevState);
    };

    // Funktion für "Abmelden"
    const handleLogout = () => {
        console.log('Abmelden');
        // Hier könnte deine Logout-Logik eingefügt werden
    };

    // Effekt zum Schließen des Dropdowns, wenn außerhalb geklickt wird
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        // Event Listener für Klicks außerhalb des Dropdown-Menüs hinzufügen
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup des Event Listeners, wenn die Komponente unmountet wird
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <div className='w-full h-16 border-b border-color-1 flex justify-end items-center'>
            <div className='grid-cols-4 flex items-center gap-5 mr-8 relative' ref={dropdownRef}>
                <div className='col-span-1'>
                    <div
                        className='hidden rounded-full bg-color-3 p-2 h-10 w-10 font-color-4 font-bold flex items-center justify-center border-2 border-color-1 '>
                        SG
                    </div>
                </div>
                <div className='col-span-1 font-color-4'>
                    <NavBarTopUser/>
                </div>
                {/* ChevronDownIcon als Button */}
                <div className='col-span-1 font-color-4 w-6 h-6 cursor-pointer' onClick={toggleDropdown}>
                    <ChevronDownIcon/>
                </div>
                <div className='hidden col-span-1 font-color-4 w-6 h-6 '>
                    <BellIcon/>
                </div>

                {/* Dropdown-Menü */}
                {showDropdown && <NavBarTopMenu handleLogout={handleLogout}/>}
            </div>
        </div>
    );
};

export default NavBarTop;
